import { subDays } from 'date-fns/subDays';
import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { DateFormatForDatePickerJP } from '../../../constants/date-picker-constant';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IOption } from '../../../models/ICommon';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import { TrayValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';

interface IProps extends IAddEditFormProps<any> {
  allProductOptions: IOption[];
  getProductByIdServiceHandler: (productId: number) => void;
}

const AddEditActiveTrayManagementForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={TrayValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          const date = new Date(values.CustomerDueDate);
          const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          );
          const formattedDate = localDate.toISOString().split('T')[0];

          props.submitHandler({ ...values, CustomerDueDate: formattedDate });
        }}
      >
        {() => {
          return (
            <Form className="user-form">
              {props.isLoading && <FormLoader loading={props.isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={true}
                        label="tray_id"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="TrayId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        disabled={props.id > 0}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="customer_id"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="CustomerId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="order_id"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="OrderId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_id"
                        required={true}
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductId"
                        as={FormikFormSelect}
                        options={props.allProductOptions}
                        disabled={props.id > 0}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="katashiki_1"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="Katashiki1"
                        type="text"
                        placeholder=""
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        as={FormikFormInput}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="katashiki_2"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="Katashiki2"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="kishu"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="Kishu"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="end_user_order_id"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="EndUserOrderId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="missing_parts"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="MissingParts"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="end_user_name"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="EndUserName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="process_name"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProcessName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="sub_contractor"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="SubContractor"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="sub_contractor_name"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="SubContractorName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="quantity"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="Quantity"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="invoice_number"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="InvoiceNumber"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_1"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment1"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_2"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment2"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_3"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment3"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_4"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment4"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_5"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment5"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_6"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProductComment6"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="customer_due_date"
                      />
                      <Field
                        data-testid="CustomerDueDate"
                        className="form-control"
                        name="CustomerDueDate"
                        autoComplete="off"
                        placeholder=""
                        dateFormat={DateFormatForDatePickerJP}
                        minDate={subDays(new Date(), 0)}
                        as={FormikFormDatePicker}
                      />
                    </div>
                  </div>
                  {/* <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="planned_due_dates"
                      />
                      <Field
                        data-testid="PlanedDueDate"
                        className="form-control"
                        name="PlanedDueDate"
                        autoComplete="off"
                        placeholder=""
                        dateFormat={DateFormatForDatePickerJP}
                        minDate={subDays(new Date(), 0)}
                        as={FormikFormDatePicker}
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="group"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="Group"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="current_state"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="CurrentState"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={false}
                        label="remarks"
                      />
                      <Field
                        rows={TEXTAREA_ROW_LENGTH}
                        id="Remarks"
                        className="form-control"
                        name="Remarks"
                        placeholder=""
                        type="text"
                        as={FormikFormTextArea}
                      />
                    </div>
                  </div> */}
                </div>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={props.id > 0 ? 'update' : 'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddEditActiveTrayManagementForm;
